import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "user-infos-edition" }
const _hoisted_2 = { class: "profile-form form-box" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = {
  class: "form-items",
  for: "email"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  class: "form-items",
  for: "registrationDate"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "form-items",
  for: "password"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "form-items",
  for: "passwordConfirmation"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = {
  class: "form-items",
  for: "first_name"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "form-items",
  for: "last_name"
}
const _hoisted_16 = {
  class: "form-items",
  for: "birth_date"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "form-items",
  for: "location"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "form-items" }
const _hoisted_21 = { class: "form-buttons" }
const _hoisted_22 = {
  class: "confirm",
  type: "submit"
}

import { format } from 'date-fns'
  import {
    ComputedRef,
    Ref,
    computed,
    reactive,
    ref,
    toRefs,
    onMounted,
  } from 'vue'

  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { IUserProfile, IUserPayload } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const store = useStore()

  const { user } = toRefs(props)
  const userForm: IUserPayload = reactive({
    password: '',
    password_conf: '',
    first_name: '',
    last_name: '',
    birth_date: '',
    location: '',
    bio: '',
  })
  const registrationDate = computed(() =>
    props.user.created_at
      ? format(new Date(props.user.created_at), 'dd/MM/yyyy HH:mm')
      : ''
  )
  const loading = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  let displayModal: Ref<boolean> = ref(false)

  onMounted(() => {
    if (props.user) {
      updateUserForm(props.user)
    }
  })

  function updateUserForm(user: IUserProfile) {
    userForm.first_name = user.first_name ? user.first_name : ''
    userForm.last_name = user.last_name ? user.last_name : ''
    userForm.birth_date = user.birth_date
      ? format(new Date(user.birth_date), 'yyyy-MM-dd')
      : ''
    userForm.location = user.location ? user.location : ''
    userForm.bio = user.bio ? user.bio : ''
  }
  function updateBio(value: string) {
    userForm.bio = value
  }
  function updateProfile() {
    store.dispatch(AUTH_USER_STORE.ACTIONS.UPDATE_USER_PROFILE, userForm)
  }
  function updateDisplayModal(value: boolean) {
    displayModal.value = value
  }
  function deleteAccount(username: string) {
    store.dispatch(AUTH_USER_STORE.ACTIONS.DELETE_ACCOUNT, { username })
  }

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(displayModal))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.$t('common.CONFIRMATION'),
          message: _ctx.$t('user.CONFIRM_ACCOUNT_DELETION'),
          onConfirmAction: _cache[0] || (_cache[0] = ($event: any) => (deleteAccount(_unref(user).username))),
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayModal(false)))
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(errorMessages))
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            message: _unref(errorMessages)
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _withModifiers(updateProfile, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.EMAIL')) + " ", 1),
          _createElementVNode("input", {
            id: "email",
            value: _unref(user).email,
            disabled: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.REGISTRATION_DATE')) + " ", 1),
          _createElementVNode("input", {
            id: "registrationDate",
            value: _unref(registrationDate),
            disabled: ""
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("label", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PASSWORD')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "password",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userForm).password) = $event)),
            disabled: _unref(loading)
          }, null, 8, _hoisted_9), [
            [_vModelText, _unref(userForm).password]
          ])
        ]),
        _createElementVNode("label", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PASSWORD_CONFIRMATION')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "passwordConfirmation",
            type: "password",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(userForm).password_conf) = $event)),
            disabled: _unref(loading)
          }, null, 8, _hoisted_11), [
            [_vModelText, _unref(userForm).password_conf]
          ])
        ]),
        _hoisted_12,
        _createElementVNode("label", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.FIRST_NAME')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "first_name",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userForm).first_name) = $event)),
            disabled: _unref(loading)
          }, null, 8, _hoisted_14), [
            [_vModelText, _unref(userForm).first_name]
          ])
        ]),
        _createElementVNode("label", _hoisted_15, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.LAST_NAME')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "last_name",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(userForm).last_name) = $event))
          }, null, 512), [
            [_vModelText, _unref(userForm).last_name]
          ])
        ]),
        _createElementVNode("label", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.BIRTH_DATE')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "birth_date",
            type: "date",
            class: "birth-date",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(userForm).birth_date) = $event)),
            disabled: _unref(loading)
          }, null, 8, _hoisted_17), [
            [_vModelText, _unref(userForm).birth_date]
          ])
        ]),
        _createElementVNode("label", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.LOCATION')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "location",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(userForm).location) = $event)),
            disabled: _unref(loading)
          }, null, 8, _hoisted_19), [
            [_vModelText, _unref(userForm).location]
          ])
        ]),
        _createElementVNode("label", _hoisted_20, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.BIO')) + " ", 1),
          _createVNode(_component_CustomTextArea, {
            name: "bio",
            charLimit: 200,
            input: _unref(userForm).bio,
            disabled: _unref(loading),
            onUpdateValue: updateBio
          }, null, 8, ["input", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 1),
          _createElementVNode("button", {
            class: "cancel",
            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.$router.push('/profile')), ["prevent"]))
          }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 1),
          _createElementVNode("button", {
            class: "danger",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (updateDisplayModal(true)), ["prevent"]))
          }, _toDisplayString(_ctx.$t('buttons.DELETE_MY_ACCOUNT')), 1)
        ])
      ], 40, _hoisted_3)
    ])
  ]))
}
}

})